<template>
    <div class="products-list">
        <tabs>
            <tab
                v-for="(category, index) in products"
                :key="index"
                :name="category.name"
            >
                <div class="product-category">
                    <product-item
                        v-for="product in category.dishes"
                        :key="product.id"
                        :product-item="product"
                    />
                </div>
            </tab>
        </tabs>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import { Tabs, Tab } from 'vue-tabs-component';
    import ProductItem from '@/components/products/Item';

    export default {
        components: {
            Tabs,
            Tab,
            ProductItem,
        },
        computed: {
            ...mapState({
                products: state => state.products.all,
            }),
        },
    };
</script>

<style lang="scss">
    .product {
        &-category {
            padding: 20px;
            background: #fff;
            border-radius: 6px;

            @include respond-to(md) {
                padding: 30px;
            }
        }

        &-item {
            &:not(:last-of-type) {
                padding-bottom: 16px;
                margin-bottom: 16px;
                border-bottom: 1px solid $athens-gray;
            }

            &-quantity {
                .button {
                    width: 48px;
                    height: 48px;
                    font-size: 18px;
                    color: #000;
                    background: $silver-chalice;

                    &[disabled] {
                        opacity: 0.2;
                    }
                }

                &-counter {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 48px;
                    height: 48px;
                    font-size: 18px;
                    font-weight: bold;
                }
            }

            &-meta {
                max-width: 60%;
            }

            &-title {
                margin-bottom: 5px;
            }

            &-summary {
                hyphens: auto;
                color: $silver-chalice;
            }

            &-price {
                font-size: 16px;
                font-weight: bold;

                @include respond-to(md) {
                    font-size: 18px;
                }

                .button {
                    margin-left: 8px;
                    background: var(--accentColor);

                    @include respond-to(md) {
                        margin-left: 32px;
                    }
                }
            }
        }

        &-extras {
            padding: 20px;
            margin-top: 10px;
            background: #f5f5f5;
            border-radius: 6px;

            .list {
                li {
                    display: flex;
                    align-items: center;
                    margin-bottom: 16px;
                    font-size: 16px;

                    input {
                        margin-right: 8px;
                    }
                }
            }

            &-title {
                margin-bottom: 16px;
                font-size: 24px;
                font-weight: bold;
            }
        }
    }

    .tabs-component-tab {
        position: relative;
        margin: 0 21px;

        &::after {
            display: block;
            width: 0;
            height: 2px;
            margin: 6px auto;
            content: '';
            background: transparent;
            border-radius: 4px;
            transition: 0.25s ease;
            transition-property: width, background;
        }

        &.is-active {
            a {
                color: var(--baseColor);
            }

            &::after {
                width: 20px;
                background: var(--baseColor);
            }
        }

        a {
            font-weight: bold;
            color: $silver-chalice;
            text-decoration: none;
            white-space: nowrap;
            transition: color 0.25s ease;

            &::first-letter {
                text-transform: uppercase;
            }

            &:hover {
                color: var(--baseColor);
            }
        }

        &:first-child {
            margin-left: 0;
        }

        &s {
            display: inline-flex;
            align-items: center;
            max-width: 100%;
            padding: 0;
            margin: 16px 0;
            overflow: auto;
            list-style: none;
        }
    }
</style>
